<template>
  <div>
    <div v-if="showTitle" class="d-flex justify-space-between">
      <p class="font-weight-black"><span v-if="allowEdit">EDITAR</span> ASISTENCIA</p>
    </div>
    <v-form ref="formAgent" lazy-validation>
      <v-row class="fill-height px-3 py-2">
        <v-col cols="12" class="d-flex">
          <div v-if="getTicket.agent_id && !loading">
            <v-avatar size="48px" color="black">
              <img
                v-if="getAllAgentsMap[getTicket.agent_id].photo"
                :src="getAllAgentsMap[getTicket.agent_id].photo"
                alt="Avatar"
              />
              <span v-else class="white--text text-h5">
                {{ getAllAgentsMap[getTicket.agent_id].full_name.substring(0, 1) }}
              </span>
            </v-avatar>
          </div>
          <div v-else>
            <v-avatar size="50px" color="black">
              <span class="white--text text-h5">-</span>
            </v-avatar>
          </div>

          <v-autocomplete
            v-model="agentId"
            :items="agentsFiltered"
            :value="getTicket.agent_id"
            item-text="full_name"
            item-value="uid"
            label="Agente"
            placeholder="Sin asignar"
            class="pl-2"
          />
        </v-col>
        <v-col v-if="responseMessage" cols="12">
          <v-alert text type="error">
            {{ responseMessage }}
          </v-alert>
        </v-col>
        <v-col v-if="allowEdit" cols="12" class="text-center">
          <v-btn :loading="loading" small rounded color="primary" @click="onSave"> Guardar </v-btn>
          <v-btn small rounded @click="onCancel"> Cancelar </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TicketCardObjection",
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    editAgent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agentId: null,
      loading: false,
      responseMessage: null,
    };
  },
  computed: {
    ...mapGetters(["getAgent", "getTicket", "getAgentsToArray", "getAllAgentsMap", "getProjectsMap"]),
    allowEdit() {
      return this.getTicket && this.getTicket.agent_id !== this.agentId;
    },
    agentsFiltered() {
      let agents = [...(this.getAgentsToArray || [])];

      if (this.getTicket.project && this.getProjectsMap[this.getTicket.project]?.custom_derive_agents) {
        const projectAgents = this.getProjectsMap[this.getTicket.project].agents || [];
        agents = agents.filter((agent) => projectAgents.includes(agent.uid) || agent.uid === this.getTicket.agent_id);
      }

      return agents;
    },
  },
  watch: {
    "getTicket.agent_id"(value) {
      if (!this.agentId) this.agentId = value;
    },
    allowEdit(value) {
      this.$emit("update:editAgent", value);
    },
  },
  created() {
    this.agentId = this.getTicket.agent_id;
  },
  methods: {
    ...mapActions(["setTicketAgent"]),
    async onSave() {
      try {
        this.loading = true;
        this.responseMessage = null;

        if (!this.$refs.formAgent.validate())
          throw new Error("El formulario contiene datos inválidos, por favor verifique y vuelva a intentar");

        await this.setTicketAgent({
          id: this.getTicket.id,
          agentId: this.agentId,
        });
      } catch (error) {
        this.responseMessage = error.message || "Ocurrió un problema al actualizar el agente de la oportunidad";
      } finally {
        this.loading = false;
      }
    },
    async onCancel() {
      this.agentId = this.getTicket.agent_id;
      this.responseMessage = null;
    },
  },
};
</script>
